// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"565":"47cd65a1","578":"2a4cf90f","767":"d5443b79","787":"643268f2","984":"ff845641"}[chunkId] + ".chunk.js";
};